const BackgroundLocationPage = () => {
  return (
    <article
      className={`prose lg:prose-lg dark:prose-invert mx-auto p-6 bg-white dark:bg-neutral-900 rounded-2xl shadow-sm `}
    >
      <header>
        <h1 className="text-2xl font-semibold">
          Tratamiento de Datos de Ubicación (Incluye Ubicación en Segundo Plano)
        </h1>
      </header>

      <section>
        <h2>Primera. - Tipos de Datos de Ubicación que Recopilamos</h2>
        <p>
          Beeapp Ecuador Cía. Ltda. puede recopilar datos de ubicación de
          precisión (GPS) para los taxistas y conductores registrados en nuestra
          plataforma. Esto incluye:
          <ul>
            <li>
              Ubicación en primer plano, cuando el conductor está usando
              activamente la app.
            </li>
            <li>
              Ubicación en segundo plano, cuando el conductor ha marcado su
              estado como activo / disponible para recibir viajes, incluso si la
              app no está visible en pantalla o está en segundo plano.
            </li>
          </ul>
        </p>
        Estos datos se procesan únicamente con el permiso explícito del
        conductor cuando activa estos servicios en la aplicación.
      </section>

      <section>
        <h2>Segunda. - Propósito de la Recopilación y Uso</h2>
        <p>
          La ubicación en segundo plano se utiliza exclusivamente para los
          siguientes fines operativos:
          <ul>
            <li>
              Permitir que BeeApp asigne viajes de manera eficiente, enviando
              solicitudes de servicio a los conductores más cercanos a una
              solicitud de viaje.
            </li>
            <li>
              Permitir la optimización de la ruta y la estimación del tiempo de
              llegada mientras el conductor está activo.
            </li>
            <li>
              Facilitar funciones esenciales del servicio que requieren
              conocimiento de la posición en tiempo real incluso cuando la app
              no está en primer plano.
            </li>
          </ul>
        </p>
      </section>

      <section>
        <h2>
          Tercera. - Condiciones de Recopilación de Ubicación en Segundo Plano
        </h2>
        <p>

          BeeApp solo accede y procesa datos de ubicación en segundo plano
          cuando:
        <ul>
          <li>El conductor ha iniciado sesión. .</li>
          <li>
            El conductor ha marcado su estado como activo / disponible para
            recibir viajes.
          </li>
          <li>
            El conductor ha aceptado los permisos de ubicación solicitados por
            el sistema operativo.
          </li>
          <li>
            Si el conductor detiene su estado activo o cierra sesión, la
            recopilación de datos de ubicación en segundo plano se suspende
            inmediatamente.
          </li>
        </ul>
        </p>
      </section>

      <section>
        <h2>Cuarta. - Permiso y Control del Usuario</h2>
        <p>
          Al instalar y usar la aplicación, el conductor otorga permiso para
          recopilar datos de ubicación. El conductor puede en cualquier momento:
          <ul>
            <li>
Revisar o cambiar los permisos de ubicación (incluido permitir o
          bloquear la ubicación en segundo plano) desde los Ajustes del
          dispositivo.
            </li>
            <li>

           Desactivar su disponibilidad para recibir viajes, lo que
          deshabilita automáticamente la recopilación de ubicación en segundo
          plano.
            </li>
          </ul>
        </p>
      </section>

      <section>
        <h2>Quinta. - Conservación y Protección de Datos de Ubicación</h2>
        <p>
          Los datos de ubicación se conservan solo mientras sean necesarios para
          prestar el servicio y según lo permitido por la legislación aplicable.
          Implementamos medidas de seguridad técnicas y organizativas para
          proteger estos datos contra acceso no autorizado, uso indebido o
          divulgación.
        </p>
      </section>
    </article>
  );
};

export default BackgroundLocationPage;
